/**
* @file Route: projectsingle
*
* This file is compiled as a standalone entrypoint and it is included by
* default in its blade template.
* This is a "standard" route, it does not have a structure to follow, you are
* sure the DOM is always ready and the JS will only be executed in this route.
*/

import "layouts/main";
import { $, $all } from "@olmokit/dom";
import { globalData } from "@olmokit/core/data";
import { timerCheck } from "components/Popup";
import "components/Cover";
import { VisualVideo } from "components/VisualVideo";
import { VisualPlus } from "components/VisualPlus"; 
import "components/VisualDownload";
import projects from "components/VisualProjects";
import { VisualHighlights } from "components/VisualHighlights";
import products from "components/VisualProducts";
import "components/VisualPhoto";
import "components/VisualQuote";
import "components/VisualCredits";
import "components/VisualText";
import slider from "components/VisualSlider";
import "components/VisualBox";
import "components/VisualTwin";
import "components/VisualAccordion";
import { CardProduct } from "components/CardProduct";
import { ShareOn } from "components/ShareOn";
import { replaceFragment } from "@olmokit/core/fragments";
import { FormType } from "components/Form";
import { datalayerProd } from "components/Datalayer";
import "./index.scss";

console.log("Route projectsingle/index.js mounted.");
timerCheck();
VisualPlus();
VisualVideo();

  CardProduct();

VisualHighlights();
ShareOn();
replaceFragment("contactForm", "components.FormType").then(() => FormType());
// FormType();

const glideEl = $all(".glide");
if (glideEl.length > 0) {
    for (let item of globalData.sliders) {
        if (item.name == 'slider')  {
            slider('.VisualSlider:slider_'+item.id);
        }
        else if (item.name == 'looks' || item.name == 'products')  {
            products('.VisualProducts:slider_'+item.id);
        }
        else if (item.name == 'projects')  {
            projects('.VisualProjects:slider_'+item.id);
        }
    }
    if (globalData.sliderprojects) {
        projects('.VisualProjects:'+globalData.sliderprojects);
    }
}

const area = $('.projectsingle:product');

if (area) {
    area.addEventListener('click',function(e){
        if (e.target.classList.contains('gtm-prodtitle')) {
            datalayerProd(e.target.getAttribute('data-product'), 'false', 'false');
        }
    });
}